// extracted by mini-css-extract-plugin
module.exports = {"content":"ImportCsvModal_content__3GtrN","schemaTable":"ImportCsvModal_schemaTable__12s4K"};